import { createSlice } from '@reduxjs/toolkit';

const BOCDeviceConnectionServiceSlice = createSlice({
  name: 'BOCDeviceConnectionService',
  initialState: {
    loading: false,
    BOCDeviceConnectionService: null,
    error: null,
    success: false
  },
  reducers: {
    fetchBOCDeviceConnectionRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchBOCDeviceConnectionSuccess(state, action) {
      state.loading = false;
      state.success = true;
      state.BOCDeviceConnectionService = action.payload;
    },
    fetchBOCDeviceConnectionFailure(state, action) {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },
    fetchBOCDeviceConnectionReset(state) {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.BOCDeviceConnectionService = null;
    }
  },
});

export const { 
  fetchBOCDeviceConnectionRequest, 
  fetchBOCDeviceConnectionSuccess, 
  fetchBOCDeviceConnectionFailure,
  fetchBOCDeviceConnectionReset 
} = BOCDeviceConnectionServiceSlice.actions;

export default BOCDeviceConnectionServiceSlice.reducer;
